const BASE_URL = process.env.REACT_APP_API_KEY;

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  // window.location.href = "/";
};

const handleResponse = (r) => {
  if (r.status === 401) {
    logout();
    return Promise.reject(new Error("Token expired"));
  }
  return r.json();
};

const ApiConfig = {
  get: (endpoint) =>
    fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: getHeaders(),
    }).then(handleResponse),

  post: (endpoint, body) =>
    fetch(`${BASE_URL}${endpoint}`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(body),
    }).then(handleResponse),
};

export default ApiConfig;
